import React from "react";
import Button from "./Button";
import { Stack, Typography } from "@mui/material";

const ConfirmModal = (props: {
    onCancel: () => void;
    onConfirm: () => void;
    title?: string;
    cancelText?: string;
    confirmText?: string;
    loading?: boolean;
}) => {
    const { onCancel, onConfirm, title, cancelText, confirmText, loading } =
        props;

    return (
        <Stack
            className="force-dynamic-translation"
            position="absolute"
            top="50%"
            left="50%"
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            width="85%"
            padding={2}
            bgcolor="white"
            borderRadius="14px"
            boxShadow="0px 4px 17px 0px #0000000A"
            sx={{
                transform: "translate(-50%, -50%)",
            }}
        >
            <Typography variant="h6" component="h2">
                {title ?? "Are you sure?"}
            </Typography>
            <Stack direction="row" width="100%" spacing={2}>
                <Button
                    variant="medium"
                    fullWidth
                    onClick={onCancel}
                    disabled={loading}
                >
                    {cancelText ?? "No"}
                </Button>
                <Button
                    variant="medium"
                    fullWidth
                    onClick={onConfirm}
                    disabled={loading}
                >
                    {confirmText ?? "Yes"}
                </Button>
            </Stack>
        </Stack>
    );
};

export default ConfirmModal;
